import React from 'react';
import { HeaderProps } from '../types';
import GameTitle from './GameTitle';
import Information from './Information';
import './Header.css';

const Header: React.FC<HeaderProps> = (props) => {
  const {
    title,
    user,
    onBackClick,
    onInfoClick,
    onNotificationClick,
    onSettingsClick,
    onQRScanClick,
    onTop10Click
  } = props;
  return (
    <div className="header-container" data-name="Header">
      <GameTitle
        title={title}
        onBackClick={onBackClick}
        onInfoClick={onInfoClick}
      />
      
      <Information
        user={user}
        onNotificationClick={onNotificationClick}
        onSettingsClick={onSettingsClick}
        onQRScanClick={onQRScanClick}
        onTop10Click={onTop10Click}
      />
    </div>
  );
};

export default Header;
